<template>
  <div class="content">
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card :data-background-color="progressBackground">
          <template slot="header">
            <md-icon>{{ sentimentIcon }}</md-icon>
          </template>

          <template slot="content">
            <p class="category">{{ $t('optimization_progress') }}</p>
            <h3 class="title">{{ optimizationProgress }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-progress-bar md-mode="determinate" :md-value="progress" class="md-accent progress-bar"></md-progress-bar>
            </div>
          </template>
        </stats-card>
      </div>
      <div
          class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>add_task</md-icon>
          </template>

          <template slot="content">
            <p class="category">{{ $t('possible_optimizations') }}</p>
            <h3 class="title">{{ optimizationsCount }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              {{ $t('last_scan') }}
            </div>
          </template>
        </stats-card>
      </div>
      <div
          class="md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25"
      >
        <md-button class="big-button" v-on:click="startScan"><md-icon class="big-button-icon">radar</md-icon>
          {{ $t('start_scan_button') }}</md-button>
      </div>

      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-66"
      >
        <nav-tabs-card>
          <template slot="content">
            <span class="md-nav-tabs-title">{{ $t('kanban_tuner_table_header') }}</span>
            <md-tabs class="md-warning" md-alignment="left">
              <md-tab id="tab-renner" v-bind:md-label="$t('runner')" md-icon="directions_run">
                <p-s-table
                        height="400"
                        showHeader="false"
                        v-bind:data="this.runners"
                        v-bind:dict="this.dict"
                        v-bind:onSelect="this.onSelect"
                ></p-s-table>
              </md-tab>
              <md-tab id="tab-penner" v-bind:md-label="$t('sleeper')" md-icon="hotel">
                <p-s-table
                        height="400"
                        showHeader="false"
                        v-bind:data="this.sleepers"
                        v-bind:dict="this.dict"
                        v-bind:onSelect="this.onSelect"
                ></p-s-table>
              </md-tab>
              <md-tab id="tab-untypical" v-bind:md-label="$t('untypicals')" md-icon="help">
                <p-s-table
                        height="400"
                        showHeader="false"
                        v-bind:data="this.untypicals"
                        v-bind:dict="this.dict"
                        v-bind:onSelect="this.onSelect"
                ></p-s-table>
              </md-tab>
            </md-tabs>
          </template>
        </nav-tabs-card>
      </div>

      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <tuner-details></tuner-details>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
import store from '@/store/index.js';
import { StatsCard, NavTabsCard } from "@/components";
import { PSTable } from "@/components";
import TunerDetails from "../components/TunerDetails";

export default {
  components: {
    TunerDetails,
    StatsCard,
    NavTabsCard,
    PSTable
  },
  data () {
    return {
      optimizationsCount: "-",
      optimizationProgress: "-",
      progress: 0,
      showActions: false,
      progressBackground: "",
      sentimentIcon: "sentiment_neutral",
      runners: [],
      sleepers: [],
      untypicals: [],
      dict: [
        { key: 'customerArticleNumber', label: 'table_header_customer_article_number', type: 'string'},
        { key: 'customerArticleDescription', label: 'table_header_customer_article_description', type: 'string'},
        { key: 'storageLocation', label: 'table_header_storage_location', type: 'string'},
        { key: 'state', label: 'Aktion', type: 'state'},
      ],
    }
  },
  methods: {
    startScan() {
      api.startOptimizationScan().then((result) => {
        this.$notify(
          {
            message: this.$t('start_kanbantuner'),
            icon: 'info',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'primary',
            timeout: 5000
          });
        setTimeout(() => {this.$router.go()}, 2000);
      });
    },
    onSelect(item) {
      store.commit("setSelectedOptimization", item);
    }
  },
  created() {
    api.getOpenOptimizationsCount().then((result) => {
      this.optimizationsCount = result.data[0].count;
    });

    api.getOptimizations().then((result) => {
      let optimizations = result.data;

      this.runners = optimizations.filter((optimization) => {
        return optimization.type === 0 && optimization.state !== 6;
      });

      this.sleepers = optimizations.filter((optimization) => {
        return optimization.type === 1 && optimization.state !== 6;
      });

      this.untypicals = optimizations.filter((optimization) => {
        return optimization.type === 2 && optimization.state !== 6;
      });

      let finishedOptimzations = optimizations.filter((optimization) => {
        return optimization.state !== 0
      });

      if (optimizations.length !== 0) {
        this.progress = parseInt(Math.ceil(((finishedOptimzations.length / optimizations.length) * 100)).toString());
        if (this.progress > 80) {
          this.progressBackground = "green";
          this.sentimentIcon = "sentiment_very_satisfied";
        } else if (this.progress > 50) {
          this.progressBackground = "orange";
          this.sentimentIcon = "sentiment_satisfied";
        }

        this.optimizationProgress = this.progress + "%";
      }
    });
  }
};
</script>

<style scoped>
.big-button {
  width: 373px;
  height: 150px;

  background: linear-gradient(90deg, #26C6DA 0%, #00ACC1 100%);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
.md-button:not(.md-just-icon) .md-button-content i {
  font-size: 50px !important;
  height: 56px;
  display: block;
  margin-right: 50px;
}
.stats {
  width: 100%;
}
.progress-bar {
  width: 100%;
  height: 18px;
}
</style>
